import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-244937f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Requirements and talking points", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Call to Action", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Attachments", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_talking_point = _resolveComponent("input-talking-point")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_upload_input = _resolveComponent("upload-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.talkingPoints, (point, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: point,
        class: "p-mb-3"
      }, [
        _createElementVNode("h6", null, "Talking Point " + _toDisplayString(index + 1), 1),
        _createVNode(_component_input_talking_point, {
          onChangeTalking: $setup.changedTalkingInput,
          "index-input": +index,
          "value-input": point
        }, null, 8, ["onChangeTalking", "index-input", "value-input"])
      ]))
    }), 128)),
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.addTalkingPoint && $setup.addTalkingPoint(...args))),
      class: "add-point"
    }, "+ Add Another Talking Point"),
    _hoisted_2,
    _createVNode(_component_InputText, {
      class: "default-input w-100",
      type: "text",
      modelValue: $setup.valueCallToActionInput,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.valueCallToActionInput) = $event)),
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeInstruction', $setup.valueCallToActionInput, $setup.talkingPoints))),
      placeholder: "Enter your call to action"
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createVNode(_component_upload_input, {
      onOnAddedFile: $setup.onAddedFile,
      "is-my-campaign": "",
      attachments: $props.attachments
    }, null, 8, ["onOnAddedFile", "attachments"])
  ]))
}